<template>
  <div id="app ">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",

  mounted () { },
  methods: {},
};
</script>

<style lang="less">
@import "~assets/css/global.less";
:root {
  --theme-black: #1b1718;
  --theme-grey: #f3f4f8;

  #app {
    max-width: 1920px;
    margin: 0 auto;
  }
}
.hide-upload {
  .el-upload--picture-card {
    display: none;
  }
}
// body {
//   background-image: url(./assets/img/main-ng.png);
//   background-repeat: no-repeat;
//   background-position: right bottom;
//   // margin: 0 15px;
//   overflow-x: hidden;
// }
</style>
